import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=29056c71&scoped=true&"
import script from "./ScrollableTable.vue?vue&type=script&lang=js&"
export * from "./ScrollableTable.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableTable.vue?vue&type=style&index=0&id=29056c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29056c71",
  null
  
)

export default component.exports